import { TbPlus } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { useNotificationActions, useNotificationShowCreateDialog } from "@/stores/use-notification-table";

import CreateNotificationForm from "./CreateNotificationForm";

/**
 * Dialog component for creating new notifications with form validation and submission.
 */
function CreateNotificationDialog() {
    const showCreateDialog = useNotificationShowCreateDialog();
    const { updateShowCreateNotificationDialog } = useNotificationActions();
    const onClose = () => {
        updateShowCreateNotificationDialog(false);
    };
    return (
        <CommonPopup icon={TbPlus} title={"Bildirim Oluştur"} open={showCreateDialog} size="sm" onClose={onClose}>
            <CreateNotificationForm />
        </CommonPopup>
    );
}

export default CreateNotificationDialog;
